<script setup lang="ts">
/**RowRenderer.vue - Para renderização simples das linhas de deliveries */
import type { Row, Table } from '@tanstack/vue-table';
import { FlexRender } from '@tanstack/vue-table';

import {
  TableRow,
  TableCell,
} from 'dashboard/components-shadcn/new-york/ui/table';

interface RowRendererProps {
  rows: Row<any>[];
  depth?: number;
  table: Table<any>;
  isExpanding?: boolean;
}

const props = withDefaults(defineProps<RowRendererProps>(), {
  depth: 0,
  isExpanding: false,
});

// Função para determinar classes da linha
const getRowClasses = (row: Row<any>) => {
  const baseClasses = [
    'transition-colors duration-200',
    'border-b border-n-slate-6'
  ];
  
  baseClasses.push('hover:bg-n-slate-2');
  
  if (row.getIsSelected()) {
    baseClasses.push(
      'bg-n-slate-3',
      'border-n-slate-7'
    );
  }
  
  return baseClasses.join(' ');
};
</script>

<template>
  <template v-for="row in rows" :key="row.id">
    <TableRow
      :class="getRowClasses(row)"
      :data-state="row.getIsSelected() ? 'selected' : 'default'"
    >
      <TableCell
        v-for="cell in row.getVisibleCells()"
        :key="cell.id"
      >
        <FlexRender
          :render="cell.column.columnDef.cell"
          :props="cell.getContext()"
        />
      </TableCell>
    </TableRow>
  </template>
</template>

<style scoped>
/* Estados de seleção */
:deep(tr[data-state="selected"]) {
  background-color: rgb(var(--slate-3));
}

/* Transições suaves */
:deep(tr) {
  transition: background-color 0.2s ease;
}

/* Responsividade */
@media (max-width: 768px) {
  :deep(td) {
    font-size: 0.875rem;
  }
}
</style>